import { SourceConvert } from "../SourceConvert/SourceConvert";

export class SourcesService {
    constructor() {}

    getSourceWithSubSourceArray(source, responseArray = false) {
        const sourcesMap = {
            tax: ["tax", "simplesNacional"],
            simplesNacional: ["tax", "simplesNacional"],
            personnel: ["personnel", "eSocial"],
            eSocial: ["personnel", "eSocial"]
        };
        if (sourcesMap[source]) return sourcesMap[source];
        if (responseArray) return [source];
        return source;
    }

    getMainSource({ source } = {}) {
        if (!source) return "";

        const sourcesMap = {
            simplesNacional: "tax",
            eSocial: "personnel",
            PGDAS: "tax"
        };

        if (sourcesMap[source]) return sourcesMap[source];

        return source;
    }

    getMainSourceHuman(source) {
        if (!source) return "";

        const sourcesMap = {
            simplesNacional: "fiscal",
            eSocial: "pessoal",
            PGDAS: "fiscal"
        };

        if (sourcesMap[source]) return sourcesMap[source];

        if (SourceConvert.toHuman(source)) return SourceConvert.toHuman(source);

        return source;
    }

    getSubSource(source, onlyIfExists = false) {
        if (!source) return "";

        const sourcesMap = {
            tax: "simplesNacional",
            personnel: "eSocial",
            eSocial: "eSocial",
            simplesNacional: "simplesNacional"
        };

        if (sourcesMap[source]) return sourcesMap[source];

        if (onlyIfExists) return "";

        return source;
    }

    getOtherSource(source) {
        if (!source) return "";
        const sourcesMap = {
            tax: "simplesNacional",
            personnel: "eSocial",
            simplesNacional: "tax",
            eSocial: "personnel"
        };
        if (sourcesMap[source]) return sourcesMap[source];
        return source;
    }
}
